import { Pager, PageItem } from 'bootstrap';
import React from 'react';

class SimplePager extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    let { pageCount, currentPage, onGoToPage } = this.props;

    if (!pageCount) return null;

    let prevNode = null,
      nextNode = null;

    if (currentPage > 1) {
      prevNode = (
        <PageItem onClick={() => onGoToPage(currentPage - 1)}>
          &larr; Previous Page
        </PageItem>
      );
    }

    if (currentPage < pageCount) {
      nextNode = (
        <PageItem onClick={() => onGoToPage(currentPage + 1)}>
          Next Page &rarr;
        </PageItem>
      );
    }

    return (
      <Pager>
        {prevNode}
        {nextNode}
      </Pager>
    );
  }
}

export default SimplePager;
